module.exports = __webpack_public_path__ + "static/media/secureLogin.d58c351c.svg";